import { ThemedFunctor } from '@doveit/lego';
import { css } from 'styled-components';

export const item: ThemedFunctor = ({
  theme,
  $active,
}) => css`
  display: inline-block;
  margin-right: 1rem;
  margin-top: .5rem;

  a {
    color: ${theme.palettes.brand.primary};
    line-height: 1rem;
    border-radius: 1rem;
    display: inline-block;
    text-decoration: ${$active ? 'none' : 'underline'}
  }
`;
